import { http } from "./http";

export async function listActiveCampuses() {
  return (await http.request("api/campuses/active")) || [];
}
